import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 80% 20%;
  grid-template-areas: 'grafico media';

  @media (max-width: 768px) {
    grid-template-areas:
      'grafico'
      'media';
    grid-template-columns: 100%;
  }

  .bar-item {
    clip-path: inset(0px 0px 8px 0px);

    @media (max-width: 768px) {
      clip-path: inset(0px 0px 5px 0px);
    }

    &.inactive {
      fill: rgba(11, 41, 251, 0.2);
      stroke: rgba(11, 41, 251, 0.2);
    }
  }

  .custom-bar-component {
    cursor: pointer;
  }
`;

export const AverageContainer = styled.div`
  grid-area: media;
  align-self: center;
`;

export const ContainerBar = styled.div`
  grid-area: componenteGrafico;
  position: relative;
  min-height: 440px;
`;

export const WrapBar = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
`;

export const WrapContent = styled.div`
  height: 340px;

  @media (max-width: 768px) {
    min-width: 550px;
  }
`;

export const WrapLegendAndContainer = styled.div`
  height: -10px;
  overflow-x: auto;
  grid-area: grafico;
  display: grid;
  grid-template-columns: 2% 98%;
  grid-template-areas:
    'legend componenteGrafico'
    'legendDataType legendDataType';
`;

export const Legend = styled.span`
  font-family: 'Mangueira Bold', sans-serif;
  grid-area: legend;
  transform: rotate(-90deg);
  display: inline-flex;
  justify-content: center;
  align-items: center;  
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: #001CFF;
`;

export const LegendDateType = styled.span`
  font-family: 'Mangueira Bold', sans-serif;
  grid-area: legendDataType;
  justify-self: center;  
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 15px;
  text-align: center;
  color: #001CFF;
`;

export const AverageBox = styled.div`
  position: relative;
  width: 218px;
  height: 263px;
  background: #e6eaf0;
  border-radius: 8px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const AverageBoxHeader = styled.div`
  border-bottom: 1px dashed #7a7a7a;
  padding: 12px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AverageBoxValue = styled.div`
  height: 182px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AverageBoxPeriod = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 0px 0px 8px 8px;
  height: 38px;
  background: #0b29fb;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AverageBoxValueWrap = styled.div``;

export const AverageBoxTextHeader = styled.span`
  font-family: 'Mangueira Bold', sans-serif;  
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #6f7074;
`;

export const AverageBoxTextValue = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 100;
  font-size: 37px;
  line-height: 97px;
  text-align: center;
  color: #0b29fb;
`;

export const AverageBoxTextValueUnit = styled(AverageBoxTextValue)`
  font-size: 32px;
  line-height: 39px;
  margin-left: 8px;
`;

export const AverageBoxPeriodText = styled.span`
  font-family: 'Mangueira Bold', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
`;
